var exports = {
  "k": "x936d19a0--9213bf--container",
};

module.exports = exports;
